module.exports = __webpack_public_path__ + "img/ai04.64ccf1e4.svg";